import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const assignTicket = async (username: string, ticketUniqueCode: string, serviceDate?: string) => {
    try {
        const payload: any = { ticketUniqueCode, username };
        if (serviceDate) {
            payload.serviceDate = serviceDate;
        }
        const response = await axios.put(`${API_BASE_URL}/tickets/assign`, payload, {
            withCredentials: true
        });
    } catch (error) {
        throw error;
    }
};

export interface BudgetDto {
    conceptType: 'SERVICE' | 'EQUIPMENT' | 'MATERIAL' | 'TRAVEL_EXPENSES' | 'OTHER';
    amount: number;
    description: string;
}

export interface AssignBudgetDto {
    ticketUniqueCode: string;
    budgets: BudgetDto[];
}

export const addBudgetToTicket = async (ticketUniqueCode: string, budgetList: BudgetDto[]) => {
    try {
        const payload: AssignBudgetDto = {
            ticketUniqueCode,
            budgets: budgetList
        };
        const response = await axios.put(`${API_BASE_URL}/tickets/budget`, payload, {
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};